import React, { PureComponent } from "react";
import { Button, Row, Col, Container } from "react-bootstrap";

import TimePicker from "../../../components/UI/timePicker/timePicker.jsx";
import CajaTexto from "../../../components/UI/cajaTexto/cajaTexto.jsx";
import AreaTexto from "../../../components/UI/cajaTexto/areaTexto.jsx";
import CajaTextoNumero from "../../../components/UI/cajaTexto/cajaTextoNumero.jsx";
import Select from "../../../components/UI/Select/Select";

class tabDetalles extends PureComponent {

  render() {
    const { Datos, listaCallCenter } = this.props;

    const disabled = Datos.CC_id.attributes.readOnly ? { disabled: true } : {};

    return (
      <Container>
        <Row>
          <Col>
            <Select
              id="CC_id"
              name="CC_id"
              labelText={Datos.CC_id.attributes.label}
              classNameContainer="form-group"
              className="form-control"
              value={Datos.CC_id.value}
              onChange={this.props.onSelectChanged}
              {...disabled}
              configuration={{
                valueField: "Id",
                textField: "Nombre",
                options: listaCallCenter,
              }}
            />
          </Col>
          <Col>
            <CajaTextoNumero
              id="Id"
              type="number"
              label={Datos.Id.attributes.label}
              value={Datos.Id.value}
              attributes={Datos.Id.attributes}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <CajaTexto
              id="Nombre"
              type="text"
              label={Datos.Nombre.attributes.label}
              value={Datos.Nombre.value}
              attributes={Datos.Nombre.attributes}
              onChangeInput={this.props.onChangeInput}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <AreaTexto
              id="Detalle"
              label={Datos.Detalle.attributes.label}
              value={Datos.Detalle.value}
              attributes={Datos.Detalle.attributes}
              onChangeInput={this.props.onChangeInput}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={6}>
            <h6>Hora de Atención</h6>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="form-group">
              <label>{Datos.HoraInicio.attributes.label}</label>
              <TimePicker
                name="HoraInicio"
                value={Datos.HoraInicio.value}
                onChange={this.props.onChangeDate}
                props={Datos.HoraInicio.attributes}
                dateFormat="HH:mm"
                timeIntervals={1}
              />
            </div>
          </Col>
          <Col>
            <div className="form-group">
              <label>{Datos.HoraFinal.attributes.label}</label>
              <TimePicker
                name="HoraFinal"
                value={Datos.HoraFinal.value}
                onChange={this.props.onChangeDate}
                props={Datos.HoraFinal.attributes}
                dateFormat="HH:mm"
                timeIntervals={1}
              />
            </div>
          </Col>
        </Row>
        <hr />
        <Row className="mb-3">
          <Col className="text-right">
            <div className="tooltip2">
              <span className="tooltiptext2">Cancelar</span>
              <Button variant="secondary" onClick={this.props.volverAtras}>
                Cancelar
              </Button>
            </div>
            &nbsp;
            <div className="tooltip2">
              <span className="tooltiptext2">Guardar</span>
              <Button variant="primary" onClick={this.props.ingresarDatos}>
                Guardar
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default tabDetalles;
